import React, { Fragment } from 'react'
import { Icon } from '@drifthq/tide-core'

import ProgressMeter from 'components/ProgressMeter'

import './style.css'

const ProgressMeterWithLogo = ({ currentLength, maxLength }) => (
  <Fragment>
    <Icon className="progress-meter-drift-logo" name="drift-logo-full"/>
    <ProgressMeter currentLength={currentLength} maxLength={maxLength}/>
  </Fragment>
)

export default ProgressMeterWithLogo


// WEBPACK FOOTER //
// ./src/components/ProgressMeterWithLogo/index.js